
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
    approveButtonText: {
      type: String,
      required: true,
    },
    cancelButtonText: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal(): void {
      this.$emit("close");
    },
    approve(): void {
      this.$emit("approve");
    },
  },
});
